
import UpsellPlusIcon from '~/static/campaigns/upsell-plus-icon.svg?inline';
import UpsellEarningIcon from '~/static/campaigns/earning-icon.svg?inline';
import UpsellExposureIcon from '~/static/campaigns/exposure-icon.svg?inline';
import UpsellSpreadWorldIcon from '~/static/campaigns/spread-world-icon.svg?inline';

// These props must match Icon choices in Deals model. See deals/models.py
const UPSELL_ICON = {
  appsumo_plus: UpsellPlusIcon,
  earning: UpsellEarningIcon,
  exposure: UpsellExposureIcon,
  spread_word: UpsellSpreadWorldIcon,
};

export default {
  props: {
    upsellCallout: {
      type: Object,
      required: true,
    },
  },
  computed: {
    iconComponent() {
      return UPSELL_ICON[this.upsellCallout.upsell_icon] || UpsellPlusIcon;
    },
  },
};
